<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">各位新入职的员工、大家下午好!</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       经过二天的入职培训，相信各位员工对X公司有了初步的了解，对公司的管理架构、经营范围、经营规模、业绩前景、企业文化等也有了初步的印象。公司此次培训，还将组织各位新员工参观公司的和正在规划建设的新基础。员工们经过二天的培训，有了一定的收获，对自己入职以后的工作及职业前景已经有了初步的规划，并做好了随时投入岗位工作的准备，在你们即将入岗入职之前，再与大家一起谈谈，希望通过进一步的沟通交流，促进我们的企业与新进员工步调合一，和谐共赢。下面我讲三点意见，与各位共勉。

      </p>
      <h5 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">一、面对现实，切合实际，找准目标，认真筹划</h5>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       各位都是八零、九零后的优秀毕业生，是在我们国家改革开放步入攻坚克难时期走向社会，开始工作的。你们成长的和即将工作的年代，与你们的一上代有着很大的环境差异，有一首网络民谣形象地描述了其中的部分现象：“当我们读小学的时候，读大学不要钱;我们要读大学的时候，读小学不要钱;我们还没能工作的时候，工作也是分配的;我们可以工作的时候，撞得头破血流才勉强找份饿不死人的工作做;当我们不能挣钱的时候，房子是分配的;当我们能挣钱的时候，却发现房子已经买不起了。”这种描述虽有部分夸张，但还是反映了部分现实。面对新的就业及工作环境，我们新入职大学生应该如何做呢?

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       首先、面对全新的企事业单位用人机制，必须有全新的入职态度。
       　　激烈市场竞争环境迫使企业采取全新的用人机制，即打破铁钣碗，实行“优胜劣态”的用人机制。这与你们的上一代有着很大的差别，由于教育产业化，致使现在的大学毕业生人数远超过六、七十年代出生的毕业生，加之现在的大学在专业培养方向上与市场需求的出现了一定程度的脱节，重理论教学轻实际操作，致使大多数企业的基层实际操作岗位被农民工或城市低教育者取代，这导致大学毕业生的就业环境进一步恶化;当你们被选进企事业单位从事某项工作时，企事业单位对于用人及人才的使用对比先前也有很大的变化，他们可能更注重员工的持续贡献能力与一贯的表现，而过于那种一岗定终生的就业模式早已不复存在，这是激烈的市场竞争环境逼使企业所采取的唯一途径。这就意味着你们在企业的表现及能力将决定企业对你们的奖惩及留用的唯一依据。这一现状不是一个企业的行为，而是整个社会面对竞争所采取的不自觉行为。因此各位新入职的员工切记：入职只是你们跨入企业工作的开始，今后的人生之路如何规划完全取决于你们在企业的努力成果与良好表现，即便是你们从这个企业跳往另一个更有发展前景的企业，道理都是一样的。因此我们必须要面对现实，切合实际，找准目标，认真筹划。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       其次、全新的用人机制为你们提供了良好的发展平台和广泛的职业生涯之路
       　　正是由于体制、机制的变革，使得你们这一代的大学生有着比老一代大学生更广阔的发展之路。任何事物的发展都有其两面性。“优胜劣态”的用人机制更是如此。早一辈的大学生可能是铁钣碗终生制，但由于缺少优胜劣态的竞争机制，干多干少都一样，能力大小都一样，大家都在同一平台下凭着几年一调级的薪酬机制“混”，几年下来，不管你是有名的学府毕业生还是普通大学毕业生，不管你是某个学科专家还是任劳任怨的技术人员，你所学的知识都会被淘汰，你的发展前景都会被断送，那种凭身份、凭关系就能找到好岗位的职业竞争方式可能更会伤害有知识、有能力的大学生的心，从而彻底毁去一个优秀大学生的一生。这种现象在我们这辈人中比比皆是。反之，如今的企业用人机制是全新的，是一个重人才、重能力的新环境!因此只要你是一个用心的人，一个专心为企业发展而思考、而作为的人，企业都会对你们分别青睐，都会不断地给你们新的机遇与新的挑战，你们将会与企业在良好的互动发展的格局中双赢。同时，社会也全面采用与这种全新机制接轨的模式，比如如今普遍采用的各类师的取证及注册方式，这是这种新机制的具体运用。你具备什么能力，拥有什么经验，社会将给你们出具什么样的证明，你凭借这些证明性材料，企业将会以相应的薪酬聘用你，你的能力证明材料等级越高，你所获得的报酬就越丰厚。比如现在的注册电器工程师、注册造价师、建造师、结构工程师、安全工程师、质量认证师、人力资源师、会计师等等，而所有这些师的取证，都必须需要一定的企业工作背景，和一定的知识教育背景，目前我们的企业正为你们提供了良好的工作环境和职业生涯前景，剩下的只是看各位新入职员工的努力了。

      </p>

      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       xx公司的“三支人才队伍”是：管理型人才、技术型人才、技能型人才。
       　　管理型人才发展序列就是从班组(队)长、分(子)部门负责人、公司经理(副经理)、集团公司高管。目前公司已开始打破身份界限，率先在部分公司实现班组(队)长、部门负责人聘用上使用聘用制大中专毕业生，在xx公司等分、子公司的骨干力量及优秀管理者都得到很好地提拔使用，将来随着你们的管理经验不断提升，公司经营发展不断深入，将会有更多的优秀管理人才脱颖而出，走向更高的管理岗位。
       　　技术型人才发展序列就是助理师、中、高级师及各类资质等级师。集团公司成立了人力资源部，与社保局等单位共同负责对各类师的取证组织办理，并有专门的文件对各类师的薪酬待遇进行统一管理，让有一定专业特长的人充分发挥他们的水平，同时体现对他们知识价值的认可，对应地提高他们各方面的待遇。
       　　技能型人才发展序列就是各类专业等级证书，如技工、高级技工、电焊工、吊装工等，集团公司人力资源部将组织集团公司各分、子公司各类技能业务能手进行技能等级鉴定，并对取得相应证书的技能人才给予相应的薪酬。
       　　通过以上分析介绍，希望广大新入职员工充分认清形势，结合企业与自身实际，找准入职后发展目标，启动人生职业生涯规划，实现企业与个人发展共赢新局面。

      </p>
      <h5 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">二、咬住目标，持续努力，永不言弃，坚信成功</h5>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       各位新入职员工，我们既然确定了发展目标，就应该锁定自己的目标，根据目标制订详细的实现步骤，分段实施，要持之以恒，不弃不离，要通过持续努力与不断实践的过程，提升自己的能力，更新自己的知识，实现自我的完美人生。
       　　俗话说得好：“师傅领进门，修行在各人!”。作为一个早于你们毕业二十多年的先行者，我在当初入职时也有你们现在一样的境遇，也有着良好的前景规划和美好的人生目标。但理想在实施过程中的确不是那么回事，我们在实际工作中也不可避免地面临着困难、挫折，甚至有心灰竟冷的时候，与我同时代的大学生也有着与我同样的困境与思虑。二十多年的路走下来，与我们同时代的大学毕业生的现实状况产生了很大的差异：过去分配到令人羡慕单位的人，如今有的发展得很好，有的境遇很差，差到连糊口都出现问题;过去分配到比较差的单位，有些人却发展得很出色，成为行业的专家、单位的领导和私人企业家，也有少部分人因此沉沦，消极厌世，以致于一事无成，成了社会的负担。在坐的今天有 位，我们完全有理由相信，二十年后，你们中间的人再聚到一起，会有很大的变化，这是一定的。为什么会有这些变化呢?为什么总有这些变化呢?原因我想就是我在第二部分标题所讲的：有些人能将目标锁定，以坚韧的意志和持久的耐心坚持下来了，成功就属于这些人，而有些人未能咬住目标，持续努力，不断地路途放弃，结果随意时间的推移，知识的老化，年龄的增长，体力、智力的衰减，会变得一事无成。
       　　举个例子，在合肥生活的人都知道合肥有个“肖氏集团”，这个肖氏集团现在很是了得，成了合肥有名的餐饮及快捷宾馆连锁企业，可当初(1991年)，他仅是个在高新区卖盒饭的个体户，他的成功原因就是咬住一个目标，从餐饮起家，做老百姓实惠的餐饮，做适合老百姓口味的餐饮，不管遇到多大困难，他们都坚定一个目标方向不变，在接近二十年的发展历程中，公司的经营方向始终未随不断变化和充满危机的市场中改变，中间的苦衷有很多，困难与问题一个接一个，但他们兄弟没有放弃。
       　　西方有句名言：“上帝在为你关上一扇门的同时会为你打开一扇窗”，中国也有句古话叫“天无灭人之路”。我想这些名言警句对于我们这些优秀的大学生来说，更显得轻松简单。人的一生中总会遇到这样或那样的困难，我们应该以一种积极的心态去面对。即所谓的“心态决定一切、心态改变一切”。
       　　在这里再与大家分享一个小故事：从前一个小和尚向老和尚拜师求武功，老和尚爽快答应，但每天只教他一个招式，就是拿根粗棍子，对着草堆，伸手向前，一边口念“去吧!”，一边猛地向前伸棍子。小和尚练了三年，实在不耐烦，生气地向老和尚抗议，说老和尚在糊弄他，这样下去什么时候才能学到武功，老和尚说你现在已经有武功在身，可以下山了。小和尚不解，稀里糊涂下山，结果遇到不平之事，小和尚打抱不平，用棍子向仗势欺人的坏蛋一伸，坏蛋躲过去，小和尚的棍子捅向一堵坚厚的墙，墙应声而倒!小和尚自己都不相信自己的功力如此了得!
       　　其实现实生活就是如此，我们之所以未成功，可能在于我们大多数时候眼高手低了些，对目标的坚持松懈了些，中途随意放弃得多了些。比如开车，我们完全可以认真学习、细心领会、不断摸索成为节能和安全的冠军，比如电焊，我们完全可以不断钻研，结合实际，刻苦操作，成为电焊行业的顶级能手。再说个例子吧，我的老家庐江县城有个做豆腐的，好象姓叶，他做的豆腐就是比别人好吃，因此他家的豆腐根本不用外买，附近的人主动到他家买，逢年过节，他家的豆腐更是供不应求，买豆腐的从凌晨三点就排队，一直到晚上九十点才停，庐江城里人以自己买到老叶家的豆腐为自豪。你们说做豆腐有多大的难事，有什么高科技?可他能把豆腐做出这样的水平，是不是从平淡中看到了伟大，从坚持中悟出真理?
       　　因此眼界决定一切，心态决定一切!因此我们要从平凡中悟出伟大，从低俗中悟出高雅，把眼界看高一些，平时不与周边的小人小事计较，把手脚放低一些，多做一些看似最没有前途的事，只要你咬准目标，持续努力，永不言弃，你就一定会成功!

      </p>
      <h5 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">三、积极储能，随时准备，接受挑选，担当大任</h5>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       接下来同学们，各位新入职的员工，你们将要做的就是积极储能，随时准备。
       　　首先是体能上的准备
       　　这一点尤为重要。俗话说“身体是革命的本钱!”，没有一个强壮的身体，没有旺盛的精力，想做什么都是白谈。我想，人的一生如果有一个完整的体能上锻炼的计划，那么对自己的事业、家庭是至关重要的。首先良好的体质是每个人赖以生存的本钱，你们现在还都年轻，随着年龄的增长，工作与家庭压力的增加，你们的身体会逐渐难以适应双重的压力，因此，乘着年轻，多锻炼身体，并养成良好的运动健身习惯，将使你们受益终生。其次持之以恒的体能锻炼，也是训练你们毅力和坚强你们意志力的有效途径，“夏炼三伏冬炼三九”将大大提高你们的意志力，提高你们适应生活与工作压力的能力，对你们的工作与家庭都有着很大的帮助。八零、九零后的大学生是在网络环境中长大的大学生，网络是一种新型媒体，有着诸多的优点，我就是我们国家早期的计算机专业毕业的，对于网络的优点及其广泛应用有着比较全面的认识，但网络带给你们这一代的负面影响还是有的，其中重要的一点就是使你们这一代人上网“运动”的时间多了，现实运动的时间少了，希望你们多从不同角度思考，克服弊端，坚持强身健体，为自己的未来储备足够的体能。
       　　其次是知识上的准备
       　　可能你们要说了，我们在大学四年，学的知识应该不少了，怎么还提知识上的准备呢!庄子说过：“吾生也有涯，而知也无涯。”知识无穷无尽，更何况你们在学校学到的只是理论知识，与现实工作中的实际还是有着一定的差距的!因此，面对新的岗位、面对新的工作，我们要不断地梳理自己的知识结构，重新思考适应新的工作所需要的知识准备，制订一个长久的学习计划，不断提升自己的工作能力。这一点相信各位新入职的员工应该很容易认识清楚的。
       　　第三是能力、经验与智慧上的储备
       　　知识不等于能力，能力不等于经验，经验不等于智慧。在具体工作实践中，你们会发现，书本的知识对于现实有着很大的差别，千万别死啃书本，在实践中注重的是能力与经验的运用，能力是通过对知识与实践的不断思考和体验所得出来的，因此我们在平时的工作中要做个有心人，即所谓的“处处留心皆学问，落花水面积文章”!，经验是不断学习总结他人的成功与失败的事例和自己的成败得失所提练出来的，因此我们大学生们应该深入基层，向最低层的员工学习，向老员工学习，向业务骨干和优秀管理者学习，要有耐心，要以全面的眼光看待生活与工作中的形形色色的人和事，要站在高处看待一切事物，要善于总结正反两方面的经验教训。当我们坚持学习，不断实践，勤于思考，善于总结，积累经验，不断否定自我，提升自我，我们就会逐渐成为有智慧的，成为对企业、对社会、对家庭有贡献的人，这样我们的人生才会至善至美!

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       我们期待着你们成功，我们坚信你们一定能成功!

      </p>

    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/yanjiang/4.vue